import parseDialogue from "../../util/parseDialogue";

export const SpinnerF3 = parseDialogue(`
spinner:f3:100-200

#100 Hey, knew I could count on you! Pharmhaus is reporting everything all clear. Here's the software they promised.
>200 Ready to receive software transfer.
`);
